var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"hidden","name":"userTimezone","id":"userTimezone"},domProps:{"value":_vm.userTimezone}})
}
var staticRenderFns = []

export { render, staticRenderFns }